if (!customElements.get('delivery-reassurance')) {
  class DeliveryReassurance extends HTMLElement {
    constructor() {
      super();
      this.threshold = Number(this.dataset.threshold) || 0;

      // Bind to on:variant:change event for this product
      const product = this.closest('.product');
      const variantPicker = product ? product.querySelector('variant-picker') : null;
      if (variantPicker) {
        variantPicker.addEventListener('on:variant:change', this.handleVariantChange.bind(this));
      }
    }

    /**
     * Shows the message only while the selected variant is priced at or above the threshold.
     * @param {object} evt - Event object
     */
    handleVariantChange(evt) {
      if (evt.detail.variant) {
        this.hidden = evt.detail.variant.price < this.threshold;
      }
    }
  }

  customElements.define('delivery-reassurance', DeliveryReassurance);
}
